import './collection-banner.scss';
export default class BreadcrumbTop {
    constructor() {
        this.placeholder = document.querySelector('.js-breadcrumb-placeholder');
        this.main = document.getElementById('MainContent');
        const collectionBannerTransparent = document.querySelector('.js-collection-banner-transparent');
        const collectionBannerHasImage = document.querySelector('.js-collection-banner-image');

        if (!this.placeholder || !this.main) return;

        if (collectionBannerTransparent) {
            this.main.classList.add('js-breadcrumbs-over-image');
        } else if (collectionBannerHasImage) {
            this.main.classList.add('js-breadcrumbs-absolute');
            this.main.classList.add('js-breadcrumbs-over-image');
        } else {
            return;
        }

        this.setBreadcrumbTop = this.setBreadcrumbTop.bind(this);

        this.setBreadcrumbTop();
        window.addEventListener('resize', this.setBreadcrumbTop);
    }

    setBreadcrumbTop() {
        const top = this.placeholder.getBoundingClientRect().top - this.main.getBoundingClientRect().top;
        document.documentElement.style.setProperty('--breadcrumbs-top', Math.max(0, top) + 'px');
    }
}
